import { cn } from '../lib/utils';
import { LayoutGrid, List } from 'lucide-react';

export function ViewSwitch({ view, onViewChange, className }) {
  return (
    <div className={cn('flex items-center bg-slate-100 rounded-lg p-1', className)}>
      <button
        onClick={() => onViewChange('grid')}
        className={cn(
          'p-2 rounded-md transition-colors',
          view === 'grid' 
            ? 'bg-white text-cyan-600 shadow-sm' 
            : 'text-slate-500 hover:text-slate-700'
        )}
        title="Grid view"
        data-testid="view-grid"
      >
        <LayoutGrid className="w-4 h-4" />
      </button>
      <button
        onClick={() => onViewChange('list')}
        className={cn(
          'p-2 rounded-md transition-colors',
          view === 'list' 
            ? 'bg-white text-cyan-600 shadow-sm' 
            : 'text-slate-500 hover:text-slate-700'
        )}
        title="List view"
        data-testid="view-list"
      >
        <List className="w-4 h-4" />
      </button>
    </div>
  );
}
